<template>
    <section style="background-image: url('images/hero-2.png')" class="pt-5">

        <Nav/>

        <div class="container rrc-intro-container d-flex align-items-center">
            <div class="row">
                <div class="col-md-8">
                    <h1 class="rrc-typo-shadow" v-html="$t('home.hero.title')"></h1>
                    <p class="rrc-lead">{{ $t('home.hero.content1') }}</p>
                </div>
            </div>
        </div>

    </section>
</template>

<script setup>
import Nav from "@/components/Nav";
</script>